import { Input } from '@sainsburys-tech/luna-form';
import { FilledButton } from '@sainsburys-tech/luna-button';

export default function FileUpload({ onChange, onClick, acceptExtension, name }) {
    
    return (
        <>
            <Input type="file" accept={acceptExtension} onChange={onChange} />
            <FilledButton style={{ height: 'fit-content', marginRight: '5px' }} onClick={onClick}>{name}</FilledButton>
        </>
    )
}